$(".custom-ing-tabs").click(function(){
  $(this).parents(".custom-ing-item").find(".custom-ing-tabs-content").hide();
  $(this).parent().find(".custom-ing-tabs").removeClass("active");
  $(this).addClass("active");
  let title = $(this).attr("data-title");
  $(this).parents(".custom-ing-item").find(`.custom-ing-tabs-content[data-title="${title}"]`).fadeIn(300);
})
$(".custom-faq-title").click(function(){
  $(this).toggleClass("active");
  $(this).next(".custom-faq-content").slideToggle(300);
})
$(".custom--top-btn").click(function(e){
  let href = $(this).attr("href");
  if(href.indexOf("#") != -1){
    let top = $(href).offset().top;
    e.preventDefault();
    $("html, body").animate({ scrollTop: top }, 500);
  }
})
$(".cws2-product-checkbox-input").change(function(){
  let cid = document.querySelector('.product-form input[name="id"]').getAttribute("value");
  document.querySelectorAll(".custom-master-li").forEach(function(item){
  if(item.getAttribute("data-vid") == cid){
    if(document.querySelector(".cws2-product-checkbox-input:checked")){
      console.log("hasChcked")
      document.querySelector("#price-button").innerText = item.getAttribute("data-plus-addon-price");
      
      var formData = new FormData();
      let vid = $(".cws2-product-option").attr("data-variant-id");
      formData.append(`updates[${vid}]`, 1);
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data));
    }
    else{
      console.log("hasntChcked")
      document.querySelector("#price-button").innerText = item.innerText;

      var formData = new FormData();
      let vid = $(".cws2-product-option").attr("data-variant-id");
      formData.append(`updates[${vid}]`, 0);
      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log(data));
    }
  
  }
  })
})

// document.addEventListener('DOMContentLoaded', function() {
//   class CWS2ProductSelector {
//     constructor() {
//       this.cartItems = new Map();
//       this.initializeEventListeners();
//       this.initializeCartState();
//       document.addEventListener('cart:updated', () => this.handleCartUpdate());
//     }

//     async handleCartUpdate() {
//       await this.initializeCartState();
//       this.updateCheckboxStates();
//     }

//     async initializeCartState() {
//       try {
//         const cart = await fetch('/cart.js').then(res => res.json());
//         this.cartItems.clear();
//         cart.items.forEach(item => {
//           this.cartItems.set(item.variant_id.toString(), item.key);
//         });
//         this.updateCheckboxStates();
//       } catch (error) {
//         console.error('CWS2 Error initializing cart:', error);
//       }
//     }

//     updateCheckboxStates() {
//       document.querySelectorAll('.cws2-product-option').forEach(option => {
//         const variantId = option.dataset.variantId;
//         const checkbox = option.querySelector('.cws2-product-checkbox-input');
//         checkbox.checked = this.cartItems.has(variantId);
//       });
//     }

//     initializeEventListeners() {
//       document.querySelectorAll('.cws2-product-checkbox-input').forEach(checkbox => {
//         checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
//       });

//       document.querySelectorAll('form[action="/cart/add"] [name="add"]').forEach(button => {
//         button.addEventListener('click', async (e) => {
//           e.preventDefault();
//           await this.handleMainAddToCart();
//         });
//       });
//     }

//     async handleMainAddToCart() {
//       try {
//         // Add main product
//         await this.addMainProduct();
        
//         // Add checked items
//         const checkedVariants = Array.from(document.querySelectorAll('.cws2-product-checkbox-input:checked'))
//           .map(checkbox => checkbox.closest('.cws2-product-option').dataset.variantId);

//         if (checkedVariants.length > 0) {
//           await this.addMultipleToCart(checkedVariants);
//         }

//         await this.updateCartTotal();
//         this.updateCheckboxStates();
//       } catch (error) {
//         console.error('CWS2 Error during add to cart:', error);
//       }
//     }

//     async addMainProduct() {
//       const form = document.querySelector('form[action="/cart/add"]');
//       if (!form) return;

//       const formData = new FormData(form);
//       try {
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           body: formData
//         });
//       } catch (error) {
//         console.error('CWS2 Error adding main product:', error);
//         throw error;
//       }
//     }

//     async addMultipleToCart(variantIds) {
//       try {
//         const items = variantIds.map(id => ({
//           id,
//           quantity: 1,
//           properties: { '_cws2_upsell': 'true' }
//         }));

//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ items })
//         });
//       } catch (error) {
//         console.error('CWS2 Error adding multiple items:', error);
//         throw error;
//       }
//     }

//     async handleCheckboxChange(event) {
//       const checkbox = event.target;
//       const variantId = checkbox.closest('.cws2-product-option').dataset.variantId;
      
//       checkbox.disabled = true;
//       try {
//         if (checkbox.checked) {
//           await this.addProductToCart(variantId);
//         } else {
//           await this.removeProductFromCart(variantId);
//         }
//         await this.updateCartTotal();
//         this.updateCheckboxStates();
//       } catch (error) {
//         console.error('CWS2 Error updating cart:', error);
//       }
//       checkbox.disabled = false;
//     }

//     async addProductToCart(variantId) {
//       try {
//         const response = await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: variantId, quantity: 1 })
//         });
//         const item = await response.json();
//         this.cartItems.set(variantId, item.key);
//       } catch (error) {
//         console.error('CWS2 Error adding product:', error);
//         throw error;
//       }
//     }

//     async removeProductFromCart(variantId) {
//       try {
//         const itemKey = this.cartItems.get(variantId);
//         if (itemKey) {
//           await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: itemKey, quantity: 0 })
//           });
//           this.cartItems.delete(variantId);
//         }
//       } catch (error) {
//         console.error('CWS2 Error removing product:', error);
//         throw error;
//       }
//     }

//     async updateCartTotal() {
//       try {
//         const cart = await fetch('/cart.js').then(res => res.json());
//         const totalPrice = cart.items.reduce((sum, item) => sum + item.final_line_price, 0);
        
//         document.querySelectorAll('.cart-count-bubble').forEach(element => {
//           element.textContent = cart.item_count;
//         });
        
//         document.querySelectorAll('.cart-price').forEach(element => {
//           element.textContent = Shopify.formatMoney(totalPrice, theme.moneyFormat);
//         });
        
//         document.dispatchEvent(new CustomEvent('cart:updated', {
//           bubbles: true,
//           detail: { cart }
//         }));
//       } catch (error) {
//         console.error('CWS2 Error updating cart total:', error);
//       }
//     }
//   }

//   if (document.querySelector('.cws2-custom-product-selector')) {
//     new CWS2ProductSelector();
//   }
// });

// $(function(){
//   const checkSubInterval = setInterval(checkSub, 100);
//   let found = false;
//   function checkSub() {
//     console.log("finding...")
//     if($(".custom-sub-points-wrapper").length > 0 && $("#trustapps-sub-options").length > 0){
//       console.log("found!!!");
//       clearInterval(checkSubInterval);
//       let subPoints = $(".custom-sub-points-wrapper").detach()
//       $("#trustapps-sub-options .spg-grid").append(subPoints);
//       if(!found){
//         found = true;
//         if($(".spg-price .original-price").length > 0 && $(".spg-price .price-difference").length > 0){
//           let op = parseFloat($(".spg-price .original-price").text().replace("RON", "").trim());
//           let pd = parseFloat($(".spg-price .price-difference").text().replace("RON", "").trim());
//           if(op <= pd){
//             $("#trustapps-sub-options .spg-price").addClass("custom-spg--hide");
//           }
//         }
//       }
//     }
//   }
// })


// $(function () {
//   const checkSubInterval = setInterval(checkSub, 100);

//   function checkSub() {
//     console.log("finding...");
    
//     // Check if both elements exist
//     if ($(".custom-sub-points-wrapper").length > 0 && $(".subify-selling-plan-whole-wrapper").length > 0) {
//       console.log("found!!!");
//       clearInterval(checkSubInterval);

//       // Detach the element to move it
//       let subPoints = $(".custom-sub-points-wrapper").detach();

//       // Append it after .subify-selling-plan-whole-wrapper
//       $(".subify-selling-plan-whole-wrapper").after(subPoints);
//     }
//   }
// });




$(function () {
  const checkSubInterval = setInterval(checkSub, 100);
  setTimeout(function(){
    clearInterval(checkSubInterval);
  }, 6000)

  function checkSub() {
    console.log("finding...");
    
    // Check if both elements exist
    if ($(".custom-sub-points-wrapper-top").length > 0 && $(".subify-selling-plan-whole-wrapper").length > 0) {
      console.log("found!!!");
      clearInterval(checkSubInterval);

      // Detach the element to move it
      let subPoints = $(".custom-sub-points-wrapper-top").html();

      // Append it after .subify-selling-plan-whole-wrapper
      setTimeout(function(){
      $(".subify-selling-plan-whole-wrapper").after(subPoints);
      }, 500)

      // Detach the element to move it
      let onePoints = $(".custom-one-points-wrapper-top").html();

      // Append it after .subify-selling-plan-whole-wrapper
      setTimeout(function(){
      $("#subify-widget-one-time-purchase-text").parents(".subify-choice-box-wrapper").find("div").eq(0).after(onePoints);
      }, 500)

      setTimeout(function(){
      $(".product__info-wrapper .product-form__submit #price-button").text($(".subify-choice-box-wrapper.active .subify-choice-price").text());
      }, 500)

      $(document).on("click", ".subify-choice-box-wrapper > div:first-child", function(e){
        e.stopPropagation();
        // console.log("test", $(this).find(".subify-choice-price").text());
        $(".product__info-wrapper .product-form__submit #price-button").text($(this).find(".subify-choice-price").text());
      })
      $(document).on("click", ".subify-selling-plan-option-box", function(e){
        e.stopPropagation();
        // console.log("test", $(this).find(".subify-selling-plan-price").text());
        $(".product__info-wrapper .product-form__submit #price-button").text($(this).find(".subify-selling-plan-price").text());
      })
    }
  }
});

$(".custom-mobile-menu-toggle").click(function(e){
  e.preventDefault();
  $(this).toggleClass("active");
  $(this).next(".custom-mobile-menu-ul").slideToggle(300);
})

$(".custom-search-icon").click(function(){
  $(".custom-search--drawer").addClass("active");
  $(".custom-drawer-overlay").fadeIn(300);
})

$(".new-header-icon").click(function(){
  $(".custom-menu--drawer").addClass("active");
  $(".custom-drawer-overlay").fadeIn(300);
})

$(".custom-drawer-close, .custom-drawer-overlay").click(function(){
  $(".custom-drawer-overlay").fadeOut(300);
  $(".custom-menu--drawer, .custom-search--drawer").removeClass("active");
})

function AddProductsToCart(productsArr, $this){
  $this.addClass("active");
  let formData = {
    'items': productsArr,
    sections: "cart-drawer,cart-icon-bubble"
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    console.log("response", res);
    if(res.status){
      console.log(res);
    }
    else{
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty"); $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(() => {
    $this.removeClass("active");
  });
}

$(document).on("click", ".custom-drawer-upsell-qty-plus", function(e){
  let qty = parseInt($(this).parent().find(".custom-drawer-upsell-qty-input").val()) + 1;
  $(this).parent().find(".custom-drawer-upsell-qty-input").val(qty);
})

$(document).on("click", ".custom-drawer-upsell-qty-minus", function(e){
  let qty = parseInt($(this).parent().find(".custom-drawer-upsell-qty-input").val());
  if(qty >= 2){
    let fqty = qty - 1;
    $(this).parent().find(".custom-drawer-upsell-qty-input").val(fqty);
  }
})

$(document).on("click", ".custom-drawer-upsell-atc", function(e){
  let arr = [];
  let qty = parseInt($(this).parent().find(".custom-drawer-upsell-qty-input").val());
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': qty });
  AddProductsToCart(arr, $(this));
})

$(document).on("click", ".custom-cart-upgrade", function(){
  let $this = $(this);
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  let fvid = $(".custom-cart-first-item").attr("data-vid");
  let formData = {
      'line': 1,
      'quantity': 0
    };
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(res => {
    console.log("response", res);
    if(res.status){
      console.log(res);
    }
    else{
      AddProductsToCart(arr, $this);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
})

$(document).on("click", ".subify-choice-wrapper .checkbox-label", function(){
  let span = $(this).children("span").text().toLowerCase().trim();
  console.log(span);
  if(span == 'abonament'){
    console.log("sub")
    $(".sp-price .sp-price-sub").attr("style", "display: inline");
    $(".sp-price .sp-price-single").hide();

    if ($(".custom-sub-points-wrapper-top").length > 0) {
      let subPoints = $(".custom-sub-points-wrapper-top").html();
      $(".subify-selling-plan-whole-wrapper").after(subPoints);
    }
  }
  else{
    console.log("single")
    $(".sp-price .sp-price-sub").hide();
    $(".sp-price .sp-price-single").attr("style", "display: inline");

    if ($(".custom-one-points-wrapper-top").length > 0) {
      let onePoints = $(".custom-one-points-wrapper-top").html();
      $("#subify-widget-one-time-purchase-text").parents(".subify-choice-box-wrapper").find("div").eq(0).after(onePoints);
    }
  }
})


$(document).ready(function(){
  $('.product-form__input--pill input:not(input[type=radio].disabled+label.second-option)+label').first().click();
$(document).on("click", ".dog-opts", function () { 
    setTimeout(function () {
        $('.variants-13').find('fieldset:eq(1) label').first().trigger('click'); 
    }, 1000);
});
});




// 8/18/26
// $(document).ready(function () {
//   $('.custom-drawer-menu-product-container').slick({
//     slidesToShow: 1.5,
//     slidesToScroll: 1,
//     infinite: false,
//     arrows: true,
//     dots: false,
//     responsive: [
//       {
//         breakpoint: 749,
//         settings: {
//           slidesToShow: 1.5,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });
// });
(function ($) {

  /* =====================================================
     INITIALIZE UPSELL SLICK SLIDER
  ===================================================== */

  function initUpsellSlider() {


      const $slider = $('.custom-drawer-menu-product-container');

      /*
       * If Slick is already initialized,
       * destroy it first to prevent duplicate sliders.
       */
      if ($slider.hasClass('slick-initialized')) {
        //$slider.slick('unslick');
      }

      /*
       * Initialize Slick
       */
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
    prevArrow: $('.hk-slider-cart-prev'),
    nextArrow: $('.hk-slider-cart-next')
      });


  }


  /* =====================================================
     INITIAL PAGE LOAD
  ===================================================== */

  $(document).ready(function () {
    initUpsellSlider();
  });


$(document).on("click", "a#cart-icon-bubble", function(e){
   e.preventDefault();
    const $slider_cart = $('.custom-drawer-menu-product-container');

      /*
       * If Slick is already initialized,
       * destroy it first to prevent duplicate sliders.
       */
      if ($slider_cart.hasClass('slick-initialized')) {
        //$slider.slick('unslick');
      }

      /*
       * Initialize Slick
       */
      $slider_cart.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
    prevArrow: $('.hk-slider-cart-prev'),
    nextArrow: $('.hk-slider-cart-next')
      });
  });


  /* =====================================================
     REINITIALIZE AFTER CART DRAWER UPDATE
  ===================================================== */

  $(document).on(
    'shopify:section:load',
    function () {
      initUpsellSlider();
    }
  );


  /* =====================================================
     WATCH FOR CART DRAWER DOM CHANGES
     
     This handles AJAX cart updates where Dawn replaces
     the cart drawer HTML.
  ===================================================== */

  const observer = new MutationObserver(function (mutations) {

    let shouldReinitialize = false;

    mutations.forEach(function (mutation) {

      if (!mutation.addedNodes.length) return;

      mutation.addedNodes.forEach(function (node) {

        if (node.nodeType !== 1) return;

        if (
          $(node).find('.custom-drawer-menu-product-container').length ||
          $(node).is('.custom-drawer-menu-product-container')
        ) {
          shouldReinitialize = true;
        }

      });

    });

    if (shouldReinitialize) {

      /*
       * Small delay so the new cart HTML is fully inserted
       */
      setTimeout(function () {
        initUpsellSlider();
      }, 50);

    }

  });


  /* =====================================================
     START OBSERVER
  ===================================================== */

  const cartDrawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('#CartDrawer');

  if (cartDrawer) {
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });
  }


})(jQuery);

// $(document).on('change', '.cart-item-variant-select__input', async function () {
//   const select = $(this);
//   const newVariantId = Number(select.val());
//   const cartItem = select.closest('.cart-item');

//   if (!newVariantId || !cartItem.length) return;

//   const oldKey = cartItem.attr('data-line-key');
//   const quantity =
//     Number(cartItem.find('.quantity__input').val()) || 1;

//   const oldValue = select.val();

//   select.prop('disabled', true);
//   cartItem.addClass('is-loading');

//   try {
//     /*
//      * First get the current cart.
//      * We need the line key because Dawn uses Shopify cart line keys.
//      */
//     const cartResponse = await fetch('/cart.js');
//     const cart = await cartResponse.json();

//     const oldItem = cart.items.find(item => item.key === oldKey);

//     if (!oldItem) {
//       throw new Error('Cart item not found');
//     }

//     /*
//      * Remove old line
//      */
//     const removeResponse = await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         id: oldKey,
//         quantity: 0
//       })
//     });

//     if (!removeResponse.ok) {
//       throw new Error('Unable to remove old variant');
//     }

//     /*
//      * Add new variant
//      */
//     const addResponse = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         items: [{
//           id: newVariantId,
//           quantity: quantity
//         }]
//       })
//     });

//     if (!addResponse.ok) {
//       throw new Error('Unable to add new variant');
//     }

//     /*
//      * Get updated Dawn cart drawer
//      */
//     const sectionResponse = await fetch(
//       window.Shopify.routes.root +
//       '?sections=cart-drawer'
//     );

//     const sections = await sectionResponse.json();

//     const parser = new DOMParser();

//     const newDocument = parser.parseFromString(
//       sections['cart-drawer'],
//       'text/html'
//     );

//     /*
//      * Replace only cart items.
//      * Do NOT replace <cart-drawer>.
//      */
//     const newCartItems =
//       newDocument.querySelector('#CartDrawer-CartItems');

//     const currentCartItems =
//       document.querySelector('#CartDrawer-CartItems');

//     if (newCartItems && currentCartItems) {
//       currentCartItems.innerHTML = newCartItems.innerHTML;
//     }

//     /*
//      * Update checkout total
//      */
//     const newCheckout =
//       newDocument.querySelector('#CartDrawer-Checkout');

//     const currentCheckout =
//       document.querySelector('#CartDrawer-Checkout');

//     if (newCheckout && currentCheckout) {
//       currentCheckout.innerHTML = newCheckout.innerHTML;
//     }

//   } catch (error) {

//     console.error('Variant change error:', error);

//     select.val(oldValue);

//   } finally {

//     select.prop('disabled', false);
//     cartItem.removeClass('is-loading');

//   }
// });
$(document).on('change', '.cart-item-variant-select__input', async function () {
  const select = $(this);
  const newVariantId = Number(select.val());
  const cartItem = select.closest('.cart-item-card'); // was: '.cart-item'

  if (!newVariantId || !cartItem.length) return;

  const oldKey = cartItem.attr('data-line-key');
  const quantity =
    Number(cartItem.find('.quantity__input').val()) || 1;

  const oldValue = select.val();

  select.prop('disabled', true);
  cartItem.addClass('is-loading');

  try {
    /*
     * First get the current cart.
     * We need the line key because Dawn uses Shopify cart line keys.
     */
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const oldItem = cart.items.find(item => item.key === oldKey);

    if (!oldItem) {
      throw new Error('Cart item not found');
    }

    /*
     * Remove old line
     */
    const removeResponse = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: oldKey,
        quantity: 0
      })
    });

    if (!removeResponse.ok) {
      throw new Error('Unable to remove old variant');
    }

    /*
     * Add new variant
     */
    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: newVariantId,
          quantity: quantity
        }]
      })
    });

    if (!addResponse.ok) {
      throw new Error('Unable to add new variant');
    }

    /*
     * Get updated Dawn cart drawer
     */
    const sectionResponse = await fetch(
      window.Shopify.routes.root +
      '?sections=cart-drawer'
    );

    const sections = await sectionResponse.json();

    const parser = new DOMParser();

    const newDocument = parser.parseFromString(
      sections['cart-drawer'],
      'text/html'
    );

    /*
     * Replace only cart items.
     * Do NOT replace <cart-drawer>.
     */
    const newCartItems =
      newDocument.querySelector('#CartDrawer-CartItems');

    const currentCartItems =
      document.querySelector('#CartDrawer-CartItems');

    if (newCartItems && currentCartItems) {
      currentCartItems.innerHTML = newCartItems.innerHTML;
    }

    /*
     * Update checkout total
     */
    const newCheckout =
      newDocument.querySelector('#CartDrawer-Checkout');

    const currentCheckout =
      document.querySelector('#CartDrawer-Checkout');

    if (newCheckout && currentCheckout) {
      currentCheckout.innerHTML = newCheckout.innerHTML;
    }

  } catch (error) {

    console.error('Variant change error:', error);

    select.val(oldValue);

  } finally {

    select.prop('disabled', false);
    cartItem.removeClass('is-loading');

  }
});


// option change price change upsell

$(document).on('change', '.cart-item-variant-select__input_upsell', function () {
  const select = $(this);
  const selectedOption = select.find('option:selected');

  const price = Number(selectedOption.attr('data-price')) || 0;
  const comparePrice = Number(selectedOption.attr('data-compare-price')) || 0;

  const wrapper = select.closest('.cart-drawer-upsell-price-wrapper');

  if (!wrapper.length) {
    console.log('Upsell wrapper not found');
    return;
  }

  console.log('Selected variant:', selectedOption.val());
  console.log('Price:', price);
  console.log('Compare price:', comparePrice);

  /*
   * Update main price
   */
  const priceElement = wrapper.find('.custom-cart-org-price');

  if (priceElement.length) {
    priceElement.text('$' + (price / 100).toFixed(2));
  }

  /*
   * Update compare price + saving
   */
  const compareElement = wrapper.find('.custom-cart-comp-price');
  const saveElement = wrapper.find('.custom-cart-save-price');

  if (comparePrice > price) {

    const saving = comparePrice - price;

    compareElement
      .text('$' + (comparePrice / 100).toFixed(2))
      .show();

    saveElement
      .text('Save $' + (saving / 100).toFixed(2))
      .show();

  } else {

    compareElement.hide();
    saveElement.hide();

  }

  /*
   * Update selected variant ID
   */
  const addButton = wrapper.find('.custom-drawer-upsell-atc');

  if (addButton.length) {
    addButton.attr('data-id', selectedOption.val());
  }

  select.attr('data-current-variant', selectedOption.val());
});





// reviews show inside cart drawer
function updateJudgeMeCartRatings() {
  document
    .querySelectorAll('.cart-item-card__rating .jdgm-prev-badge') // was: '.cart-item-judge-stars .jdgm-prev-badge'
    .forEach(function (badge) {
      const count = badge.getAttribute('data-number-of-reviews');
      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (text && count && text.textContent !== `(${count})`) {
        text.textContent = `(${count})`;
      }
    });
}
document.addEventListener('DOMContentLoaded', updateJudgeMeCartRatings);
const observer = new MutationObserver(function () {
  updateJudgeMeCartRatings();
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});



// coupen code start

// document.addEventListener('click', async function (event) {

//   const button = event.target.closest(
//     '.custom-cart-discount-input-btn'
//   );

//   if (!button) return;

//   const box = button.closest(
//     '.custom-cart-discount-input'
//   );

//   const input = box.querySelector(
//     '.custom-cart-discount-input-field'
//   );

//   const error = box.querySelector(
//     '.custom-cart-discount-input-error'
//   );

//   const success = box.querySelector(
//     '.custom-cart-discount-input-success'
//   );

//   const code = input.value.trim();

//   error.hidden = true;
//   success.hidden = true;

//   if (!code) {
//     error.textContent = 'Please enter a discount code.';
//     error.hidden = false;
//     return;
//   }

//   button.disabled = true;
//   button.textContent = 'Checking...';

//   try {

//     const response = await fetch(
//       window.Shopify.routes.root + 'cart/update.js',
//       {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify({
//           discount: code
//         })
//       }
//     );

//     const cart = await response.json();

//     console.log('Updated cart:', cart);
//     console.log('Discounts:', cart.discount_codes);

//     const discount = cart.discount_codes?.find(
//       item => item.code.toLowerCase() === code.toLowerCase()
//     );

//     if (discount && discount.applicable) {

//       success.textContent =
//         'Discount code applied successfully!';

//       success.hidden = false;

//       input.value = '';

//       /*
//        * Tell Dawn cart drawer to refresh
//        */
//       document.dispatchEvent(
//         new CustomEvent('cart:updated', {
//           detail: { cart }
//         })
//       );

//       /*
//        * Reload drawer contents
//        */
//       const sections = await fetch(
//         window.Shopify.routes.root +
//         '?sections=cart-drawer,cart-icon-bubble'
//       ).then(res => res.json());

//       const drawer = document.querySelector('cart-drawer');

//       if (drawer && sections['cart-drawer']) {

//         const parser = new DOMParser();

//         const doc = parser.parseFromString(
//           sections['cart-drawer'],
//           'text/html'
//         );

//         const newDrawer =
//           doc.querySelector('cart-drawer');

//         if (newDrawer) {
//           drawer.innerHTML = newDrawer.innerHTML;
//         }
//       }

//     } else {

//       error.textContent =
//         'The discount code is invalid or cannot be added to this cart.';

//       error.hidden = false;

//     }

//   } catch (error) {

//     console.error('Discount error:', error);

//     error.textContent =
//       'Unable to apply the discount code. Please try again.';

//     error.hidden = false;

//   } finally {

//     button.disabled = false;
//     button.textContent = 'Claim';

//   }

// });
(function ($) {
  'use strict';

  function getGiftCoupon() {
    return $('[data-gift-coupon]').first();
  }

  function showError(message) {
    var $c = getGiftCoupon();
    if (!$c.length) return;
    $c.find('.custom-cart-discount-input-success').prop('hidden', true);
    $c.find('.custom-cart-discount-input-error').text(message).prop('hidden', false);
  }

  function showSuccess(message) {
    var $c = getGiftCoupon();
    if (!$c.length) return;
    $c.find('.custom-cart-discount-input-error').prop('hidden', true);
    $c.find('.custom-cart-discount-input-success').text(message).prop('hidden', false);
  }

  function hideMessages() {
    var $c = getGiftCoupon();
    if (!$c.length) return;
    $c.find('.custom-cart-discount-input-error').prop('hidden', true);
    $c.find('.custom-cart-discount-input-success').prop('hidden', true);
  }

  // Clears Shopify's sticky discount_code cookie set by /discount/{code}.
  // Run window.hkClearDiscountCookie() in the console to clean up a
  // browser stuck with a stale test code.
  function clearStaleDiscountCookie() {
    document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  async function getCart() {
    var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    if (!res.ok) throw new Error('Unable to get cart.');
    return res.json();
  }

  async function addGiftToCart() {
    var $c = getGiftCoupon();
    if (!$c.length) throw new Error('Gift coupon element not found.');

    var configuredCode = String($c.data('gift-code') || '').trim().toLowerCase();
    var variantId = String($c.attr('data-gift-variant-id') || '').trim();

    var cart = await getCart();
    var existingGift = cart.items.find(function (item) {
      return String(item.variant_id) === variantId && item.properties && item.properties['hk_free_gift'] === 'true';
    });
    if (existingGift) return { cart: cart, added: false, item: existingGift };

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: { 'hk_free_gift': 'true', '_gift_coupon': configuredCode }
        }]
      })
    });

    var data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Unable to add gift product.');

    var updatedCart = await getCart();
    var addedGift = updatedCart.items.find(function (item) {
      return String(item.variant_id) === variantId && item.properties && item.properties['hk_free_gift'] === 'true';
    });
    if (!addedGift) throw new Error('Gift was added but disappeared from the cart immediately.');

    return { cart: updatedCart, added: true, item: addedGift };
  }

  async function refreshDawnCart() {
    var res = await fetch('/?sections=cart-drawer,cart-icon-bubble,cart-live-region-text', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    });
    if (!res.ok) throw new Error('Unable to refresh cart drawer.');

    var sections = await res.json();
    var cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      var cart = await getCart();
      cartDrawer.renderContents({ sections: sections, item_count: cart.item_count });
      return;
    }

    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.renderContents === 'function') {
      cartDrawerItems.renderContents(sections['cart-drawer']);
      return;
    }

    $(document).trigger('cart:updated', { sections: sections });
  }

  async function verifyGiftAfterRefresh() {
    await new Promise(function (resolve) { setTimeout(resolve, 500); });

    var $c = getGiftCoupon();
    var variantId = String($c.attr('data-gift-variant-id') || '').trim();
    var cart = await getCart();

    var gift = cart.items.find(function (item) {
      return String(item.variant_id) === variantId && item.properties && item.properties['hk_free_gift'] === 'true';
    });

    return !!gift;
  }

  /*async function claimGift() {
    hideMessages();

    var $c = getGiftCoupon();
    if (!$c.length) return;

    var $input = $c.find('.custom-cart-discount-input-field');
    var $button = $c.find('.custom-cart-discount-input-btn');
    var configuredCode = String($c.attr('data-gift-code') || '').trim().toLowerCase();
    var variantId = String($c.attr('data-gift-variant-id') || '').trim();
    var successText = $c.attr('data-success-message') || 'Gift added successfully!';
    var errorText = $c.attr('data-error-message') || 'The discount code is invalid or cannot be added to this cart.';
    var enteredCode = String($input.val() || '').trim().toLowerCase();

    if (!enteredCode) { showError('Please enter your gift code.'); return; }

    // Safety-net check for direct calls (e.g. window.hkClaimGift).
    // The click handler already validates this before applyDiscountCode() runs.
    if (configuredCode && enteredCode !== configuredCode) { showError(errorText); return; }

    $button.prop('disabled', true).addClass('is-loading');
    var originalButtonText = $button.text();
    $button.text('Se adaugă...');

    try {
      if (variantId) {
        await addGiftToCart();
      }

      $button.text('Se actualizează...');
      await refreshDawnCart();

      if (variantId) {
        var stillExists = await verifyGiftAfterRefresh();
        if (!stillExists) {
          throw new Error('The gift was removed while updating the cart. Check for another cart script or app.');
        }
      }

      showSuccess(successText);

    } catch (error) {
      showError(error.message || errorText);

    } finally {
      $('.custom-cart-discount-input-btn').first()
        .prop('disabled', false)
        .removeClass('is-loading')
        .text(originalButtonText);
    }
  }*/

  // WARNING: hitting /discount/{code} sets Shopify's sticky discount_code
  // cookie, which keeps re-applying on future carts until replaced/cleared.
  // Only call this with a code already validated against configuredCode.

function applyDiscountCode(code) {
  code = String(code || '').trim().toLowerCase();

  var $error = $('.custom-cart-discount-input-error');

  $error.text('').prop('hidden', true);

  if (!code) {
    return Promise.reject(new Error('Discount code is empty.'));
  }

  var restrictedCodes = ['z8kp56', 'm3wx74', 't9rq28', 'x5nv67'];

  if (restrictedCodes.includes(code)) {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Failed to fetch cart.');
        }

        return res.json();
      })
      .then(function (cart) {
        // Shopify cart total is in the store's currency subunits.
        // For RON (lei), 150 lei = 15000 bani.
        var minimumAmount = 15000;

        if (cart.total_price < minimumAmount) {
          var errorMessage = 'Este necesară o comandă de minimum 150 lei.';

          $error.text(errorMessage).prop('hidden', false);

          throw new Error(errorMessage);
        }

        // Cart meets the minimum; apply the discount normally.
        return fetch('/discount/' + encodeURIComponent(code), {
          credentials: 'same-origin'
        }).then(function (res) {
          if (!res.ok) {
            throw new Error('Failed to apply discount code.');
          }

          return res;
        });
      });
  }

  return fetch('/discount/' + encodeURIComponent(code), {
    credentials: 'same-origin'
  }).then(function (res) {
    if (!res.ok) {
      throw new Error('Failed to apply discount code.');
    }

    return res;
  });
}


  // Validates the entered code against the configured code BEFORE ever
  // calling applyDiscountCode() — prevents unmatched codes from setting
  // Shopify's discount cookie in the first place.
$(document).on('click', '.custom-cart-discount-input-btn', function (event) {
  event.preventDefault();
  event.stopPropagation();

  var $button = $(this);
  var $c = $button.closest('[data-gift-coupon]');
  var $input = $c.find('.custom-cart-discount-input-field');

  var errorText = $c.attr('data-error-message') ||
    'The discount code is invalid or cannot be added to this cart.';

  var enteredCode = String($input.val() || '').trim().toLowerCase();

  if (!enteredCode) {
    showError('Please enter your gift code.');
    return;
  }

  /*
   * Find the matching configured gift code
   * and its corresponding variant ID.
   *
   * If no matching code is found, we still
   * allow the discount code to be applied.
   */
  var variantId = '';

  for (var i = 1; i <= 6; i++) {
    var giftCode = String($c.attr('data-gift-code' + i) || '')
      .trim()
      .toLowerCase();

    if (giftCode && giftCode === enteredCode) {
      variantId = String(
        $c.attr('data-gift-variant-id' + i) || ''
      ).trim();

      break;
    }
  }

  /*
   * Disable button while processing.
   */
  $button
    .prop('disabled', true)
    .addClass('is-loading')
    .text('Se adaugă...');

  /*
   * ALWAYS apply the entered discount code,
   * even if it isn't one of the configured codes.
   */
  applyDiscountCode(enteredCode)
    .then(function () {

      /*
       * Matching configured code + variant ID
       */
      if (variantId) {
        return claimGift(variantId);
      }

      /*
       * Unknown code OR configured code without
       * a gift variant.
       */
      $button.text('Se actualizează...');

      return refreshDawnCart();
    })
    .catch(function (error) {
      showError(
        error.message || errorText
      );
    })
    .finally(function () {
      $button
        .prop('disabled', false)
        .removeClass('is-loading')
        .text('Aplică');
    });
});

  $(document).on('keydown', '.custom-cart-discount-input-field', function (event) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    event.stopPropagation();
    $(this).closest('[data-gift-coupon]').find('.custom-cart-discount-input-btn').trigger('click');
  });







  function claimGift(variantId) {
  if (!variantId) {
    return Promise.resolve();
  }

  variantId = Number(variantId);

  /*
   * Get the current cart first.
   */
  return fetch('/cart.js', {
    credentials: 'same-origin'
  })
    .then(function (res) {
      if (!res.ok) {
        throw new Error('Failed to fetch cart.');
      }

      return res.json();
    })
    .then(function (cart) {

      /*
       * Check whether the gift variant is already
       * present in the cart.
       */
      var giftAlreadyInCart = cart.items.some(function (item) {
        return Number(item.variant_id) === variantId;
      });

      /*
       * Gift already exists.
       * Don't add it again.
       */
      if (giftAlreadyInCart) {
        return refreshDawnCart();
      }

      /*
       * Gift doesn't exist, so add it.
       */
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
          properties: { 'free_gift': 'true'}
            }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error('Failed to add gift product.');
          }

          return res.json();
        })
        .then(function () {
          return refreshDawnCart();
        });
    });
}
  window.hkClaimGift = claimGift;
  window.hkApplyDiscountCode = applyDiscountCode;
  window.hkClearDiscountCookie = clearStaleDiscountCookie;






})(jQuery);